bovoApp.controller('BillingController', ['$scope', 'Billing', '$location', '$routeParams', '$filter', '$translate', 'FileUploader',
  function ($scope, Billing, $location, $routeParams, $filter, $translate, FileUploader) {
    $scope.deleted = [];
    $scope.activeTab = 'invoices'; // Default to invoices tab
    $scope.draftData = {
      expense_codes: [],
      periods: {},
      date: null
    };
    $scope.expenseCodes = [];
    $scope.selectedDraft = null;
    $scope.selectedPdfFile = null;
    $scope.draftGenerating = false;
    $scope.pdfUploading = false;
    $scope.regeneratingDraft = false;
    $scope.draftConfirm = {};

    $scope.invoiceType = $location.url().replace(/^\/|\/$/g, '');

    $scope.selectAll = function (select) {
      if (select) {
        $scope.deleted = [];
        for (let i = 0; i < $scope.data.invoices.data.length; i++) {
          $scope.deleted.push($scope.data.invoices.data[i].id);
        }
      } else {
        $scope.deleted = [];
      }
    };

    $scope.filterData = {
      station_id: [],
      price: '',
      vehicle: [],
      page: 1,
      invoice_type: $scope.invoiceType,
      date: {
        startDate: null,
        endDate: null
      }
    }

    $scope.clearFilter = function (page) {
      $scope.filterData = {
        station_id: [],
        price: '',
        vehicle: [],
        page: 1,
        invoice_type: $scope.invoiceType,
        date: {
          startDate: null,
          endDate: null
        }
      }
      $scope.all();
    }

    $scope.$on('refresh_data', function () {
      console.log('refreshing map...')
      $scope.all();
    }, true);

    $scope.$on('new_data', function () {
      $scope.invoice = {}
      $scope.new();
      $('#invoiceDetail').modal('hide');
      $('#newInvoice').modal('show');
    }, true);

    $scope.editInvoice = function (page) {
      $scope.new();
      $('#invoiceDetail').modal('hide');
      $('#newInvoice').modal('show');
    }

    $scope.getPage = function (page) {
      $scope.filterData.page = page;
      $scope.all();
    }

    $scope.all = function (type) {
      Billing.all($scope.filterData).success(function (data, status, headers, config) {
        $scope.data = data;

        if (type && type == 'open') {
          var tempInvoice = $scope.data.invoices.data.find(function (element) {
            return element.id == $scope.invoice.id;
          })
          $scope.openDetail(tempInvoice);
        }
      });
    }

    $scope.get = function () {
      Billing.get($routeParams.id).success(function (data, status, headers, config) {
        $scope.data = data;
        jQuery('#date').datetimepicker({
          timepicker: false,
          datepicker: true,
          format: 'Y-m-d'
        });
      });
    }

    $scope.new = function () {
      Billing.new().success(function (data, status, headers, config) {
        jQuery('#date').datetimepicker({
          timepicker: false,
          datepicker: true,
          format: 'Y-m-d'
        });
      });
    }

    $scope.delete = function (type) {
      if (type == 'set') {
        $('#delete').modal('show');
      } else if (type == 'delete') {
        Billing.delete($scope.deleted).success(function (data, status, headers, config) {
          Messenger().post(data.message);
          for (var i = $scope.deleted.length - 1; i >= 0; i--) {
            var index = $scope.data.invoices.data.indexOf($filter('filter')($scope.data.invoices.data, {
              id: $scope.deleted[i]
            })[0]);
            if (index > -1)
              $scope.data.invoices.data.splice(index, 1);
          }
          $scope.deleted = [];
          $('#delete').modal('hide');
        }).error(function (data) {
          Messenger().post({
            message: data.message,
            type: "error"
          });
        });
      }
    }

    $scope.save = function () {
      if ($scope.invoice.id) {
        $scope.update();
      } else {
        Billing.save($scope.invoice).success(function (data, status, headers, config) {
          $scope.data = data;
          Messenger().post(data.message);
          $('#newInvoice').modal('hide');
          $scope.all();
        }).error(function (data) {
          Messenger().post({
            message: data.message,
            type: "error"
          });
        });
      }
    }

    $scope.update = function () {
      Billing.update($scope.invoice).success(function (data, status, headers, config) {
        $scope.data = data;
        Messenger().post(data.message);
        $('#newInvoice').modal('hide');
        $scope.all('open');

      }).error(function (data) {
        Messenger().post({
          message: data.message,
          type: "error"
        });
      });
    }

    $scope.openDetail = function (data) {
      $scope.invoice = data;
      $('#invoiceDetail').modal('show');
    }

    $scope.toggleSelection = function toggleSelection(id) {
      var idx = $scope.deleted.indexOf(id);
      if (idx > -1) {
        $scope.deleted.splice(idx, 1);
      } else {
        $scope.deleted.push(id);
      }
    };

    $scope.invoice = {
      count: 3,
      invoices: []
    }

    jQuery('#date').datetimepicker({
      timepicker: false,
      datepicker: true,
      format: 'Y-m-d'
    });

    $scope.showCompletedOrders = function (invoice) {
      if ($scope.invoiceType == 'invoice') {
        var data = {
          invoice_id: invoice.id,
        }
      } else {
        var data = {
          collection_id: invoice.id,
        }
      }
      var url = 'orders?data=' + JSON.stringify(data);
      window.open(url, '_blank');
    }

    $scope.showOrdersByInvoice = function (invoice) {
      var url = 'orders?invoice_id=' + invoice.id;
      window.open(url, '_blank');
    }

    $scope.openPayment = function (payment) {
      $scope.payment = payment;
      jQuery('#payment_date').datetimepicker({
        timepicker: false,
        datepicker: true,
        format: 'Y-m-d'
      });
      $('#invoiceDetail').modal('hide');
      $('#newInvoicePayment').modal('show');
    }

    $scope.newPayment = function () {
      $scope.payment = {};
      jQuery('#payment_date').datetimepicker({
        timepicker: false,
        datepicker: true,
        format: 'Y-m-d'
      });
      $('#invoiceDetail').modal('hide');
      $('#newInvoicePayment').modal('show');
    }

    $scope.addPayment = function () {
      if ($scope.payment.id) {
        $scope.updatePayment();
      } else {
        $scope.payment.invoice_id = $scope.invoice.id;
        // $scope.payment.price = $scope.payment.rate * $scope.payment.qty;
        Billing.addPayment($scope.payment).success(function (data, status, headers, config) {
          $scope.data = data;
          Messenger().post(data.message);
          $('#newInvoicePayment').modal('hide');
          $scope.all('open');
        }).error(function (data) {
          Messenger().post({
            message: data.message,
            type: "error"
          });
        });
      }
    }

    $scope.updatePayment = function () {
      $scope.payment.price = $scope.payment.rate * $scope.payment.qty;
      Billing.updatePayment($scope.payment).success(function (data, status, headers, config) {
        $scope.data = data;
        Messenger().post(data.message);
        $('#newInvoicePayment').modal('hide');
        $scope.all('open');
      }).error(function (data) {
        Messenger().post({
          message: data.message,
          type: "error"
        });
      });
    }

    $scope.deletePayment = function (payment) {
      if (confirm($translate.instant("ARE_U_SURE_DELETE"))) {
        Billing.deletePayment(payment.id).success(function (data, status, headers, config) {
          Messenger().post(data.message);
          $scope.all('open');
        }).error(function (data) {
          Messenger().post({
            message: data.message,
            type: "error"
          });
        });
      }
    }

    $scope.getPrice = function (payment) {
      try {
        $scope.payment.price = $scope.payment.rate * $scope.payment.qty;
      } catch (error) {
      }
    }

    // Invoice File Uploader
    var invoiceFile = $scope.invoiceFile = new FileUploader({
      url: '/api/upload-invoice',
      headers: { 'X-CSRF-TOKEN': CSRF_TOKEN },
      autoUpload: true
    });

    invoiceFile.filters.push({
      name: 'formatFilter',
      fn: function (item /*{File|FileLikeObject}*/, options) {
        var type = '|' + item.type.slice(item.type.lastIndexOf('/') + 1) + '|';
        return '|xlsx|xls|vnd.openxmlformats-officedocument.spreadsheetml.sheet|vnd.ms-excel|pdf|'.indexOf(type) !== -1;
      }
    });

    invoiceFile.onAfterAddingFile = function (fileItem) {
      $scope.proccessProfile = true;
      $scope.pending = true;
    };

    invoiceFile.onCompleteItem = function (item, response, status, headers) {
      $scope.proccessProfile = false;
      $scope.invoice.invoice_path = response.file;
      if (response.status == 'success') {
        $scope.pending = false;
      }
    }


    // Excel File Uploader
    var excelFile = $scope.excelFile = new FileUploader({
      url: '/api/upload-invoice',
      headers: { 'X-CSRF-TOKEN': CSRF_TOKEN },
      autoUpload: true
    });

    excelFile.filters.push({
      name: 'formatFilter',
      fn: function (item /*{File|FileLikeObject}*/, options) {
        var type = '|' + item.type.slice(item.type.lastIndexOf('/') + 1) + '|';
        return '|xlsx|xls|vnd.openxmlformats-officedocument.spreadsheetml.sheet|vnd.ms-excel|'.indexOf(type) !== -1;
      }
    });

    excelFile.onAfterAddingFile = function (fileItem) {
      $scope.proccessProfile = true;
      $scope.pending = true;
    };

    excelFile.onCompleteItem = function (item, response, status, headers) {
      $scope.proccessProfile = false;
      $scope.invoice.order_excel_path = response.file;
      if (response.status == 'success') {
        $scope.pending = false;
      }
    }

    // Desi Düzeltme Fonksiyonları
    $scope.weightProcessing = false;
    $scope.weightResult = null;
    $scope.selectedWeightFile = null;
    $scope.currentImportId = null;
    $scope.statusCheckInterval = null;

    $scope.openWeightCorrectionModal = function () {
      $scope.weightResult = null;
      $scope.selectedWeightFile = null;
      $scope.weightProcessing = false;
      $scope.currentImportId = null;
      if ($scope.statusCheckInterval) {
        clearInterval($scope.statusCheckInterval);
        $scope.statusCheckInterval = null;
      }
      $('#weightCorrectionModal').modal('show');
    };

    $scope.downloadWeightTemplate = function () {
      window.open('/api/download-weight-template', '_blank');
    };

    $scope.onWeightFileSelect = function (files) {
      if (files && files.length > 0) {
        $scope.selectedWeightFile = files[0];
        $scope.weightResult = null;
      }
    };

    $scope.onWeightFileSelectNative = function (element) {
      if (element.files && element.files.length > 0) {
        $scope.$apply(function () {
          $scope.selectedWeightFile = element.files[0];
          $scope.weightResult = null;
        });
      }
    };

    $scope.processWeightFile = function () {
      if (!$scope.selectedWeightFile) {
        Messenger().post({
          message: "Lütfen dosya seçiniz!",
          type: "error"
        });
        return;
      }

      $scope.weightProcessing = true;
      $scope.weightResult = null;

      var formData = new FormData();
      formData.append('file', $scope.selectedWeightFile);

      $.ajax({
        url: '/api/process-weight-update',
        type: 'POST',
        data: formData,
        processData: false,
        contentType: false,
        headers: {
          'X-CSRF-TOKEN': CSRF_TOKEN
        },
        success: function (response) {
          $scope.$apply(function () {
            if (response.import_id) {
              $scope.currentImportId = response.import_id;
              $scope.startStatusCheck();
              Messenger().post({
                message: response.message,
                type: "success"
              });
            } else {
              $scope.weightProcessing = false;
              $scope.weightResult = response.data;
              Messenger().post({
                message: response.message,
                type: "success"
              });
            }
          });
        },
        error: function (xhr) {
          $scope.$apply(function () {
            $scope.weightProcessing = false;
            var errorMessage = 'Dosya işlenirken hata oluştu!';
            if (xhr.responseJSON && xhr.responseJSON.message) {
              errorMessage = xhr.responseJSON.message;
            }
            Messenger().post({
              message: errorMessage,
              type: "error"
            });
          });
        }
      });
    };

    $scope.startStatusCheck = function () {
      $scope.statusCheckInterval = setInterval(function () {
        $scope.checkImportStatus();
      }, 3000);
    };

    $scope.checkImportStatus = function () {
      if (!$scope.currentImportId) return;

      $.ajax({
        url: '/api/check-weight-update-status/' + $scope.currentImportId,
        type: 'GET',
        headers: {
          'X-CSRF-TOKEN': CSRF_TOKEN
        },
        success: function (response) {
          $scope.$apply(function () {
            if (response.status === 'completed') {
              $scope.weightProcessing = false;
              $scope.weightResult = response.response;
              $scope.priceProgress = null;
              $scope.stopStatusCheck();
              Messenger().post({
                message: response.response.message || 'İşlem tamamlandı!',
                type: "success"
              });
            } else if (response.status === 'prices_pending') {
              $scope.weightResult = response.response;
              $scope.priceProgress = response.price_progress;
              // Fiyat güncelleme devam ediyor, polling devam etsin
            } else if (response.status === 'failed') {
              $scope.weightProcessing = false;
              $scope.priceProgress = null;
              $scope.stopStatusCheck();
              Messenger().post({
                message: response.exception || 'İşlem başarısız oldu!',
                type: "error"
              });
            }
            // processing durumunda devam et
          });
        },
        error: function (xhr) {
          $scope.$apply(function () {
            $scope.weightProcessing = false;
            $scope.stopStatusCheck();
            Messenger().post({
              message: 'Durum kontrolü sırasında hata oluştu!',
              type: "error"
            });
          });
        }
      });
    };

    $scope.stopStatusCheck = function () {
      if ($scope.statusCheckInterval) {
        clearInterval($scope.statusCheckInterval);
        $scope.statusCheckInterval = null;
      }
    };

    // Modal kapatıldığında interval'ı temizle
    $('#weightCorrectionModal').on('hidden.bs.modal', function () {
      $scope.stopStatusCheck();
    });

    // Draft Invoice Functions
    $scope.switchTab = function (tab) {
      $scope.activeTab = tab;
      if (tab === 'drafts') {
        $scope.showDrafts = true;
        $scope.getDrafts();
      } else {
        $scope.showDrafts = false;
        $scope.all();
      }
    };

    $scope.getDrafts = function () {
      $scope.showDrafts = true;
      var params = Object.assign({}, $scope.filterData, { show_drafts: true });
      Billing.all(params).success(function (data, status, headers, config) {
        $scope.data = data;
      });
    };

    $scope.getDraftPage = function (page) {
      $scope.filterData.page = page;
      $scope.getDrafts();
    };

    $scope.openPdfUploadModal = function (draft) {
      $scope.selectedDraft = draft;
      $scope.selectedPdfFile = null;
      $('#pdfUploadModal').modal('show');
    };

    $scope.onPdfFileSelect = function (element) {
      if (element.files && element.files.length > 0) {
        $scope.$apply(function () {
          $scope.selectedPdfFile = element.files[0];
        });
      }
    };

    $scope.uploadPdf = function () {
      if (!$scope.selectedPdfFile || !$scope.selectedDraft) {
        Messenger().post({
          message: "PDF dosyası seçiniz!",
          type: "error"
        });
        return;
      }

      $scope.pdfUploading = true;
      var formData = new FormData();
      formData.append('pdf_file', $scope.selectedPdfFile);
      formData.append('draft_id', $scope.selectedDraft.id);

      $.ajax({
        url: '/api/upload-invoice-pdf',
        type: 'POST',
        data: formData,
        processData: false,
        contentType: false,
        headers: {
          'X-CSRF-TOKEN': CSRF_TOKEN
        },
        success: function (response) {
          $scope.$apply(function () {
            $scope.pdfUploading = false;
            Messenger().post({
              message: response.message,
              type: "success"
            });
            $('#pdfUploadModal').modal('hide');
            $scope.getDrafts();
          });
        },
        error: function (xhr) {
          $scope.$apply(function () {
            $scope.pdfUploading = false;
            var errorMessage = 'PDF yüklenirken hata oluştu!';
            if (xhr.responseJSON && xhr.responseJSON.message) {
              errorMessage = xhr.responseJSON.message;
            }
            Messenger().post({
              message: errorMessage,
              type: "error"
            });
          });
        }
      });
    };

    // New function for PDF upload with invoice number confirmation
    $scope.uploadPdfAndConfirm = function () {
      if (!$scope.selectedPdfFile || !$scope.selectedDraft) {
        Messenger().post({
          message: "PDF dosyası seçiniz!",
          type: "error"
        });
        return;
      }

      if (!$scope.selectedDraft.e_invoice_number_final) {
        Messenger().post({
          message: "Fatura numarası gereklidir!",
          type: "error"
        });
        return;
      }

      $scope.pdfUploading = true;
      var formData = new FormData();
      formData.append('pdf_file', $scope.selectedPdfFile);
      formData.append('draft_id', $scope.selectedDraft.id);
      formData.append('e_invoice_number', $scope.selectedDraft.e_invoice_number_final);

      $.ajax({
        url: '/api/upload-pdf-and-confirm',
        type: 'POST',
        data: formData,
        processData: false,
        contentType: false,
        headers: {
          'X-CSRF-TOKEN': CSRF_TOKEN
        },
        success: function (response) {
          $scope.$apply(function () {
            $scope.pdfUploading = false;
            Messenger().post({
              message: response.message || "Fatura başarıyla onaylandı ve kesin hale getirildi!",
              type: "success"
            });
            $('#pdfUploadModal').modal('hide');
            $scope.all(); // Switch back to regular invoices
            $scope.showDrafts = false;
          });
        },
        error: function (xhr) {
          $scope.$apply(function () {
            $scope.pdfUploading = false;
            var errorMessage = 'Fatura onaylanırken hata oluştu!';
            if (xhr.responseJSON && xhr.responseJSON.message) {
              errorMessage = xhr.responseJSON.message;
            }
            Messenger().post({
              message: errorMessage,
              type: "error"
            });
          });
        }
      });
    };

    $scope.convertDraftToInvoice = function (draft) {
      if (confirm('Bu taslağı faturaya çevirmek istediğinizden emin misiniz?')) {
        Billing.convertDraftToInvoice(draft.id).success(function (data) {
          Messenger().post({
            message: data.message,
            type: "success"
          });
          $scope.getDrafts();
        }).error(function (data) {
          Messenger().post({
            message: data.message,
            type: "error"
          });
        });
      }
    };

    $scope.deleteDraft = function (draft) {
      if (confirm('Bu taslağı silmek istediğinizden emin misiniz?')) {
        Billing.deleteDraft(draft.id).success(function (data) {
          Messenger().post({
            message: data.message,
            type: "success"
          });
          $('#invoiceDetail').modal('hide');
          $scope.getDrafts();
        }).error(function (data) {
          Messenger().post({
            message: data.message,
            type: "error"
          });
        });
      }
    };

    $scope.recalculateDraft = function (draft) {
      if (confirm('Bu taslak fatura o anki kargolardan yeniden hesaplanacak. Devam etmek istiyor musunuz?')) {
        $scope.recalculating = true;
        Billing.recalculateDraft(draft.id).success(function (data) {
          Messenger().post({
            message: data.message,
            type: "success"
          });
          $scope.recalculating = false;
          // Güncellenen invoice'ı scope'a aktar
          if (data.invoice) {
            $scope.invoice = data.invoice;
          }
          $scope.getDrafts();
        }).error(function (data) {
          $scope.recalculating = false;
          Messenger().post({
            message: data.message,
            type: "error"
          });
        });
      }
    };

    $scope.initFromUrl = function () {
      var urlParams = new URLSearchParams(window.location.search);
      var isDraft = urlParams.get('is_draft');
      var draftId = urlParams.get('draft_id');

      if (isDraft === '1') {
        setTimeout(() => {
          $scope.switchTab('drafts');

          if (draftId) {
            $scope.$watch('data.invoices.data', function (newVal) {
              if (newVal && newVal.length > 0) {
                var targetDraft = newVal.find(function (draft) {
                  return draft.id == Number(draftId);
                });
                if (targetDraft) {
                  setTimeout(() => {
                    $scope.openDetail(targetDraft);
                    return;
                  }, 500);
                }
              }
            });
          }
        }, 500);
      }
    };

    $scope.initFromUrl();

  }
]);